import comp0 from '@gelato/app/sentry'
import comp1 from '@gelato/app/carousel'
import comp2 from '@gelato/app/bgvideo'
import comp3 from '@gelato/app/scrollto'
import comp4 from '@gelato/app/form'
import comp5 from '@gelato/app/header'
import comp6 from '@gelato/app/navtoggle'
import comp7 from '@gelato/app/locations'
import comp8 from '@gelato/app/products'
var map={}; 
map['app/sentry']=comp0;
map['app/carousel']=comp1;
map['app/bgvideo']=comp2;
map['app/scrollto']=comp3;
map['app/form']=comp4;
map['app/header']=comp5;
map['app/navtoggle']=comp6;
map['app/locations']=comp7;
map['app/products']=comp8;
export default map;